import RequestAbstract from "../abstract";

export default class PublicAppeals extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/public-appeals";
    }

    /**
     * Approve a pending appeal, for core-cron to apply to its transaction within
     * the minute. The API checks it against the transaction as it is now and
     * refuses one that could not be applied. `text` is the approver's note, and is
     * required. `walletId` is the card the money left from, which an appeal making a
     * payout with no wallet yet withdrawed must name, unless its Telegram message
     * names it; left out otherwise.
     */
    async approve(id, text, walletId) {
        return await this.post(`${this.link}/${id}/approve`, walletId != null ? { text, walletId } : { text });
    }

    /** Reject a pending appeal: its transaction stays as it is. `text` is the reason, and is required. */
    async reject(id, text) {
        return await this.post(`${this.link}/${id}/reject`, { text });
    }
}
